/* ════════════════════════════════════════════════════════════
   section-testimonials.js
   Initializes a Swiper instance for the testimonials slider.
   ════════════════════════════════════════════════════════════ */

class TestimonialsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (this.swiper) return;

    // Swiper loads asynchronously from CDN; retry until ready.
    if (typeof Swiper === 'undefined') {
      this._retryTimer = setTimeout(() => this.init(), 50);
      return;
    }

    const container = this.querySelector('.swiper');
    if (!container) return;

    const colsDesktop = parseFloat(this.dataset.colsDesktop) || 3;
    const colsTablet = parseFloat(this.dataset.colsTablet) || 2;
    const colsMobile = parseFloat(this.dataset.colsMobile) || 1.1;
    const gap = parseInt(this.dataset.gap, 10) || 20;
    const gapMobile = parseInt(this.dataset.gapMobile, 10) || Math.round(gap / 2);

    this.swiper = new Swiper(container, {
      slidesPerView: colsMobile,
      spaceBetween: gapMobile,
      grabCursor: true,
      navigation: {
        prevEl: this.querySelector('.testimonials__nav--prev'),
        nextEl: this.querySelector('.testimonials__nav--next'),
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        750: {
          slidesPerView: colsTablet,
          spaceBetween: gap,
        },
        990: {
          slidesPerView: colsDesktop,
          spaceBetween: gap,
        },
      },
    });
  }

  disconnectedCallback() {
    if (this._retryTimer) {
      clearTimeout(this._retryTimer);
      this._retryTimer = null;
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('testimonials-slider')) {
  customElements.define('testimonials-slider', TestimonialsSlider);
}